import { render, staticRenderFns } from "./webBanners.vue?vue&type=template&id=44d3ccd8&"
import script from "./webBanners.vue?vue&type=script&lang=js&"
export * from "./webBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports